export default [
  {
    name: '台灣地區',
    code: '886'
  },
  {
    name: '中國大陸',
    code: '86'
  },
  {
    name: '馬來西亞',
    code: '60'
  },
  {
    name: '中國香港特別行政區',
    code: '852'
  },
  {
    name: '美國',
    code: '1'
  },
  {
    name: '新加坡',
    code: '65'
  },
  {
    name: '越南',
    code: '84'
  },
  {
    name: '中國澳門特別行政區',
    code: '853'
  },
  {
    name: '澳大利亞',
    code: '61'
  },
  {
    name: '加拿大',
    code: '1'
  },
  {
    name: '菲律賓',
    code: '63'
  },
  {
    name: '日本',
    code: '81'
  },
  {
    name: '泰國',
    code: '66'
  },
  {
    name: '英國',
    code: '44'
  },
  {
    name: '柬埔寨',
    code: '855'
  },
  {
    name: '印度',
    code: '91'
  },
  {
    name: '印度尼西亞',
    code: '62'
  },
  {
    name: '韓國',
    code: '82'
  },
  {
    name: '德國',
    code: '49'
  },
  {
    name: '新西蘭',
    code: '64'
  },
  {
    name: '其他',
    code: '0'
  }
]
